module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container login-cont"
  }, [_c('div', {}, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-md-4 offset-md-4"
  }, [_c('div', {
    staticClass: "box-bordered p-l-20 p-r-20 p-t-10 p-b-20 m-t-30"
  }, [_c('div', {
    staticClass: "title-login"
  }, [_vm._v("Logowanie")]), _vm._v(" "), _c('div', {
    staticClass: "m-b-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "nazwa użytkownika",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-b-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "hasło",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-align-r"
  }, [_c('button', {
    staticClass: "btn btn-orange",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zaloguj się")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71aa28fd!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Login.vue
// module id = 1102
// module chunks = 0